var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAptos = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_22059)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_141_22059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 188,
    height: 188
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_141_22059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -7,
    y: -7,
    width: 204,
    height: 204
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.878 196.878H-6.87793V-6.87805H196.878V196.878Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_141_22059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.062 95C188.062 146.414 146.414 188.062 95 188.062C43.586 188.062 1.93799 146.414 1.93799 95C1.93799 43.586 43.586 1.93799 95 1.93799C146.414 1.93799 188.062 43.586 188.062 95Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_141_22059)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_141_22059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 188,
    height: 188
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.138 1.86194H1.90015V188.1H188.138V1.86194Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_141_22059)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187.507,
    height: 186.778,
    transform: "matrix(1 0 0 -1 2.00024 189)",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.736 79.4192H113.002C111.984 79.4192 111.016 78.9825 110.342 78.2224L106.799 74.2198C106.272 73.6224 105.512 73.2825 104.717 73.2825C103.921 73.2825 103.161 73.6244 102.634 74.2198L99.5954 77.6538C98.6004 78.7765 97.1728 79.4213 95.6732 79.4213H47.8626C46.501 83.3023 45.6131 87.4017 45.2588 91.6536H90.3934C91.1865 91.6536 91.9466 91.3301 92.4946 90.7575L96.697 86.3717C97.2223 85.8238 97.9474 85.5148 98.7055 85.5148H98.8785C99.6757 85.5148 100.434 85.8567 100.961 86.4541L104.502 90.4567C105.176 91.2189 106.144 91.6536 107.162 91.6536H144.003C143.649 87.3997 142.761 83.3003 141.399 79.4213H121.734L121.736 79.4192Z",
    fill: "#274A3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5704 117.377C73.3635 117.377 74.1236 117.053 74.6716 116.481L78.874 112.095C79.3993 111.547 80.1244 111.238 80.8825 111.238H81.0555C81.8528 111.238 82.6108 111.58 83.1382 112.175L86.6793 116.178C87.353 116.94 88.3212 117.375 89.3388 117.375H139.265C141.135 113.51 142.505 109.363 143.321 105.019H95.3993C94.3817 105.019 93.4135 104.582 92.7399 103.822L89.1987 99.8195C88.6714 99.2221 87.9112 98.8822 87.1161 98.8822C86.3209 98.8822 85.5608 99.2242 85.0334 99.8195L81.9949 103.254C80.9999 104.376 79.5723 105.021 78.0706 105.021H45.9387C46.7545 109.366 48.1264 113.512 49.9949 117.377H72.5704Z",
    fill: "#274A3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.99 66.052C108.783 66.052 109.543 65.7286 110.091 65.1559L114.294 60.7702C114.819 60.2222 115.544 59.9132 116.302 59.9132H116.475C117.272 59.9132 118.03 60.2552 118.558 60.8526L122.099 64.8551C122.772 65.6173 123.741 66.052 124.758 66.052H134.253C125.212 54.034 110.831 46.2595 94.6308 46.2595C78.431 46.2595 64.0501 54.034 55.0088 66.052H107.99Z",
    fill: "#274A3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9205 129.621H75.9364C74.9187 129.621 73.9505 129.185 73.2769 128.424L69.7358 124.422C69.2084 123.825 68.4483 123.485 67.6531 123.485C66.8579 123.485 66.0978 123.827 65.5704 124.422L62.5319 127.856C61.537 128.979 60.1094 129.623 58.6076 129.623H58.4058C67.4512 139.316 80.3324 145.382 94.635 145.382C108.938 145.382 121.817 139.316 130.864 129.623H88.9205V129.621Z",
    fill: "#274A3E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94.5,
    r: 93.5,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.676 78.1185H112.919C111.898 78.1185 110.928 77.6823 110.252 76.9231L106.7 72.9255C106.171 72.3289 105.409 71.9894 104.612 71.9894C103.815 71.9894 103.053 72.3309 102.524 72.9255L99.4775 76.3553C98.4799 77.4766 97.0486 78.1206 95.5451 78.1206H47.6106C46.2454 81.9968 45.3552 86.0911 45 90.3377H90.2516C91.0468 90.3377 91.8089 90.0147 92.3582 89.4427L96.5715 85.0624C97.0982 84.5151 97.8252 84.2065 98.5852 84.2065H98.7587C99.558 84.2065 100.318 84.548 100.847 85.1447L104.397 89.1423C105.072 89.9036 106.043 90.3377 107.063 90.3377H144C143.645 86.0891 142.755 81.9947 141.389 78.1206H121.674L121.676 78.1185Z",
    fill: "#274A3E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3824 116.029C73.1775 116.029 73.9396 115.706 74.489 115.134L78.7023 110.754C79.229 110.206 79.956 109.898 80.716 109.898H80.8895C81.6888 109.898 82.4488 110.239 82.9775 110.834L86.5279 114.832C87.2032 115.593 88.1739 116.027 89.1942 116.027H139.25C141.125 112.167 142.499 108.026 143.316 103.686H95.2704C94.2502 103.686 93.2795 103.25 92.6041 102.491L89.0538 98.4934C88.525 97.8967 87.7629 97.5573 86.9657 97.5573C86.1685 97.5573 85.4064 97.8988 84.8777 98.4934L81.8313 101.923C80.8337 103.044 79.4024 103.688 77.8968 103.688H45.6816C46.4995 108.028 47.875 112.169 49.7483 116.029H72.3824Z",
    fill: "#274A3E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.894 64.7679C108.689 64.7679 109.451 64.4449 110.001 63.8729L114.214 59.4926C114.74 58.9454 115.467 58.6367 116.228 58.6367H116.401C117.2 58.6367 117.96 58.9783 118.489 59.5749L122.039 63.5726C122.715 64.3338 123.685 64.7679 124.706 64.7679H134.225C125.16 52.7648 110.742 45 94.5001 45C78.2583 45 63.8402 52.7648 54.7754 64.7679H107.894Z",
    fill: "#274A3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.775 128.259H75.7572C74.7369 128.259 73.7662 127.822 73.0908 127.063L69.5405 123.066C69.0118 122.469 68.2497 122.129 67.4525 122.129C66.6552 122.129 65.8931 122.471 65.3644 123.066L62.318 126.495C61.3205 127.617 59.8892 128.261 58.3836 128.261H58.1812C67.2501 137.941 80.1646 144 94.5043 144C108.844 144 121.756 137.941 130.827 128.261H88.775V128.259Z",
    fill: "#274A3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_22059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 190,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAptos);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aptos.549effb25220c308e2ad5ee539508e78.svg";